import { render, staticRenderFns } from "./Voicemail.vue?vue&type=template&id=00202580&"
import script from "./Voicemail.vue?vue&type=script&lang=js&"
export * from "./Voicemail.vue?vue&type=script&lang=js&"
import style0 from "./Voicemail.vue?vue&type=style&index=0&id=00202580&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports